const data = {
    products: [
        {
            id: '1',
            title: 'Air Jordan 12 GYM RED',
            price: 110.5,
            image: "https://cdn.flightclub.com/1800/TEMPLATE/805430/1.jpg",
            description : "The Air Jordan 12 Retro 'Gym Red' emerges with a Chicago Bulls mix of hues. Built with tumbled leather, the shoe's upper appears in Gym Red, with a metallic finish on the tonal eyelets. A white basketball-textured mudguard contrasts the look while supporting the fit, with black on the inner lining and heel pull-loop. Underfoot, full-length Zoom Air in the phylon midsole provides cushioning, giving way to herringbone pods on the rubber outsole for traction."
        },
        {
            id: '2',
            title: 'Air Jordan 13 RETRO DEL SOL',
            price: 200.3,
            image: "https://cdn.flightclub.com/1800/TEMPLATE/297870/1.jpg",
            description : "Combining bright accents with the influence of original color-blocking and materials is the Air Jordan 13 Retro 'Del Sol.' The white leather upper features dimpled overlays in matching white tumbled leather with a crimson Jumpman logo on the tongue and a green-tinged holographic cat eye on the lateral ankle. Yellow synthetic suede wraps the midfoot, heel, and lightweight Phylon midsole, fitted with Zoom Air cushioning in the forefoot and heel. The mid-top is built on a black panther-paw outsole with herringbone rubber pods and a carbon fiber shank plate."
        },
        {
            id: '3',
            title: 'Puma MB.01 QUEEN CITY',
            price: 180.2,
            image: "https://cdn.flightclub.com/1800/TEMPLATE/302392/1.jpg",
            description : "The Puma MB.01 QUEEN CITY emerges with a Chicago Bulls mix of hues. Built with tumbled leather, the shoe's upper appears in Gym Red, with a metallic finish on the tonal eyelets. A white basketball-textured mudguard contrasts the look while supporting the fit, with black on the inner lining and heel pull-loop. Underfoot, full-length Zoom Air in the phylon midsole provides cushioning, giving way to herringbone pods on the rubber outsole for traction."
        },
        {
            id: '4',
            title: 'DUNK LOW COURT PURPLE',
            price: 200.0,
            image: "https://cdn.flightclub.com/750/TEMPLATE/294745/1.jpg",
            description : "The DUNK LOW COURT PURPLE emerges with a Chicago Bulls mix of hues. Built with tumbled leather, the shoe's upper appears in Gym Red, with a metallic finish on the tonal eyelets. A white basketball-textured mudguard contrasts the look while supporting the fit, with black on the inner lining and heel pull-loop. Underfoot, full-length Zoom Air in the phylon midsole provides cushioning, giving way to herringbone pods on the rubber outsole for traction."
        }
        
       
    ]
}

export default data